import { instance } from "../api/axiosInstance";
import { getUserId } from "./usersApi";
const axios = instance;

export async function getListings(params) {
  params.showExternalListings = "true";
  if(!params.type){
    params.type="poi,listing"
  }
  return axios.get(`/listings`, { params });
}

export async function getPreferredListings(userId, params = {}) {
  return axios.get(`/users/${userId}/preferredListings`, {
    params: {
      ...params, isWebsite: true,
    }
  });
}

export async function updateListingsStatus(listingId, payload = {}) {
  return axios.patch(`/listings/${listingId}/status`, payload);
}

export async function getMyListing(params) {
  params.showExternalListings = "true";
  if(!params.type){
    params.type="poi,listing"
  }
  return axios.get(`/users/myListings`, { params });
}
export async function getListingsById(listingsId) {
  return axios.get(`/listings/${listingsId}`);
}

export async function postListingsData(newListingsDataObj) {
  return axios.post(`/listings`, newListingsDataObj);
}

export async function getListingsBySearch(params) {
  return axios.get(`/listings/search`, { params });
}

export async function uploadListingImage(formData, listingsId) {
  return axios.post(`/listings/${listingsId}/imageUpload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// export async function uploadMedia(listingsId, mediaType, numberOfMedia) {
//   return axios.post(`/listings/${listingsId}/mediaUpload`, {
//     mediaType, 
//     numberOfMedia
//   });
// }

export async function uploadMedia(listingsId, data) {
  return axios.post(`/listings/${listingsId}/mediaUpload`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    }
  });
}

export async function uploadToSignedUrl(url, file) {
  return axios.put(url, file, {
    headers: {
      "Content-Type": file.type
    }
  });
}

// export async function uploadMedia(formData, listingsId) {
//   return axios.post(`/listings/${listingsId}/mediaUpload`, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// }

export async function deleteMedia(listingsId, mediaIds) {
  const mediaIdsQuery = mediaIds.join(","); // Convert array to comma-separated string
  return axios.delete(
    `listings/${listingsId}/mediaDelete?mediaIds=${mediaIdsQuery}`
  );
}

export async function uploadListingPDF(formData, listingsId) {
  return axios.post(`/listings/${listingsId}/pdfUpload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function deleteListingImage(listingsId) {
  return axios.delete(`listings/${listingsId}/imageDelete`);
}

export async function uploadPDF(formData) {
  return axios.post(`/users/${getUserId()}/pdfUpload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function updateListingsData(newListingsDataObj, listingsId) {
  return axios.patch(`/listings/${listingsId}`, newListingsDataObj);
}

export async function deleteListing(listingsId) {
  return axios.delete(`listings/${listingsId}`);
}
